import React, { useMemo } from "react";
import { RenderEpicMessage, RenderOnbaseMessage } from "./RenderMessages";
import { FormatDate } from "commonFunctions/commonFunctions";

const EncounterTable = (props) => {

    const isEndDate = Object.values(props.data).map(res => res?.period?.end)

    return <table>
        <tr>
            <th>CSN</th>
            <th>Start Date</th>
            {isEndDate[0] == undefined ? "" : <th>End Date</th>}
            <th>Encounter Name/Appointment Status</th>
            {props.isKeyPresent(props.data, "onbase_confirmation") && <th style={{ textAlign: "center", width: "150px" }}>Readabl Upload to Onbase Status</th>}
            {props.isKeyPresent(props.data, "epic_confirmation") && <th style={{ textAlign: "center" }}>EPIC Status</th>}
        </tr>
        {Object.values(props.data).map((enc, i) => (
            <tr key={i}>
                <td>{enc.identifier}</td>
                <td>{enc.period?.start && FormatDate({ date: enc.period?.start, format: "MM/DD/YYYY" })}</td>
                {isEndDate[0] == undefined ? "" : <td>{enc.period?.end && FormatDate({ date: enc.period?.end, format: "MM/DD/YYYY" })}</td>}
                <td>{enc.type?.toString() || ""}</td>
                {enc.onbase_confirmation && <td><RenderOnbaseMessage data={enc} /></td>}
                {enc.epic_confirmation && <td><RenderEpicMessage data={enc} /></td>}
            </tr>
        ))}
    </table>
}

export default EncounterTable;